import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(private http: HttpClient) { }

  private appAndSDKVersions: any;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  getAppDetails(appId: any) {
    const url = '/dashboard/getappdetails';
    const params = { id: appId };

    return this.http.get<any>(url, { 'params': params }).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getAppVersionDetails(data) {
    const url = '/dashboard/getappversions';
    const params = data;

    return this.http.get<any>(url, { 'params': params }).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  getAppAndSDKVersions() {
    return this.appAndSDKVersions;
  }

  setAppAndSDKVersions(data) {
    this.appAndSDKVersions = data;
  }

  getCrumbKey(appId, is_updated_crumb_key) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const url = '/dashboard/getcrumbkey';
    let params: any = {
      'app_id': appId,
      'is_updated_crumb_key': is_updated_crumb_key
    };

    params = Object.keys(params).map(key => key + '=' + params[key]).join('&');

    return this.http.post<any>(url, params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  makedefaultlocale(appId, data) {
    const url = '/dashboard/makedefaultlocale/' + appId;

    return this.http.post<any>(url, data).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  savePNCertificate(appId, data) {
    const url = '/dashboard/app/' + appId + '/pncertificate';

    return this.http.post<any>(url, data).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  saveCustomUrl(appId, customUrl) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    const url = '/dashboard/customurlscheme';
    let params: any = {
      'custom_url_scheme': customUrl,
      'app_id': appId,
    };

    params = Object.keys(params).map(key => key + '=' + params[key]).join('&');


    return this.http.post<any>(url, params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  saveDomain(appId, companyId, domainName) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    const url = '/dashboard/domain';
    let params: any = {
      'domain_name': domainName,
      'app_id': appId,
      'company_id': companyId
    };

    params = Object.keys(params).map(key => key + '=' + params[key]).join('&');


    return this.http.post<any>(url, params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  saveIOSKey(iosCertPassword, file, appId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const url = '/dashboard/app/' + appId + '/pncertificate';
    let params: any = {
      'file': file,
      'cert_pass': iosCertPassword
    };

    params = Object.keys(params).map(key => key + '=' + params[key]).join('&');

    return this.http.post<any>(url, params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  createApp(_params, companyId) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const url = '/dashboard/createapp/';
    let params: any = {
      'app_name': _params.appName,
      'app_os': _params.appType,
      'company_id': companyId,
      'dashboard_version': '3.0'
    };

    if (_params.appType === 'web' && _params.appDomain) {
      params['domain_name'] = _params.appDomain;
    }
    if (_params.appType === 'ios' && _params.appCustomUrl) {
      params['custom_url_scheme'] = _params.appCustomUrl;
    }

    params = Object.keys(params).map(key => key + '=' + params[key]).join('&');

    return this.http.post<any>(url, params, httpOptions).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );

    /* return $http.post('/dashboard/createapp', params, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      transformRequest: common.transformRequest
    }).then(createAppComplete)
    .catch(function(message) {
      logger.log('XHR Failed for createAppComplete');
    });

    function createAppComplete(data, status, headers, config) {

      return data.data;
    } */
  }

  updateAttrDuration(data: any) {
    const endPoint = '/dashboard/attrduration';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    data = Object.keys(data).map(key => key + '=' + data[key]).join('&');

    return this.http.post<any>(endPoint, data, httpOptions).pipe(
      map(this.extractData)
    );
  }

  fetchFrequencyConfig(appId) {
    return this.http.get<any>('/dashboard/settings/nudge-frequency?app_id=' + appId).pipe(
      map((res: Response) => {
        const body = res;
        return body || {};
      })
    );
  }

  postFrequencyConfig(data) {
    const endPoint = '/dashboard/settings/nudge-frequency';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    data = Object.keys(data).map(key => key + '=' + data[key]).join('&');

    return this.http.post<any>(endPoint, data, httpOptions).pipe(
      map(this.extractData)
    );
  }
}
